import React, {memo} from 'react';
import {CONTENT_TYPES, PADDING, PAGES} from '@/constants';
import TablePreviewModule from "@/components/TablePreviewModule";
import {dynamicWithLoader, getItemType, getMapKey2} from "@/utils/utils";
import {useRouter} from "next/router";
import SubPageBanner from "@/components/Banners/SubPage/SubPageBanner";
import TypographyBanner from '@/components/Banners/Typography'

// const SubPageBanner = dynamicWithLoader(() => import('@/components/Banners/SubPage/SubPageBanner'));
// const TypographyBanner = dynamicWithLoader(() => import('@/components/Banners/Typography'))

const BannerKRS = dynamicWithLoader(() => import("@/components/Banners/KRS"));

const TabsAndImage = dynamicWithLoader(() => import('@/components/tabsAndImage/TabsAndImage'));

const DraggableLetters = dynamicWithLoader(() => import('@/components/draggableLetters/DraggableLetters'));

const NewsThumbnail = dynamicWithLoader(() => import('@/components/newsThumbnail/NewsThumbnail'));

const RulesTiles = dynamicWithLoader(() => import('@/components/rulesTiles/RulesTiles'));

const TextAndDescriptionWithButton = dynamicWithLoader(() => import('@/components/TextAndDescriptionWithButton'));

const DescriptionWithImage = dynamicWithLoader(() => import('@/components/DescriptionWithImage'));

const ContactForm = dynamicWithLoader(() => import('@/components/Forms/ContactForm'));

const Calendar = dynamicWithLoader(() => import('@/components/Calendar'));

const FAQ = dynamicWithLoader(() => import('@/components/FAQ'));

const StructuredTextModule = dynamicWithLoader(() => import('@/components/StructuredTextModule/index'));

const SocialMediaFeed = dynamicWithLoader(() => import('@/components/SocialMediaFeed'));

const Stats = dynamicWithLoader(() => import('@/components/Stats'));

const BannerCallToActionModule = dynamicWithLoader(() => import('@/components/BannerCallToActionModule'));

const BannerCallToActionPreviewModule = dynamicWithLoader(() => import('@/components/BannerCallToActionModule/Preview'));

const ImageWithCaption = dynamicWithLoader(() => import('@/components/ImageWithCaption'));

const TeamModule = dynamicWithLoader(() => import('@/components/TeamModule'));

const Payment = dynamicWithLoader(() => import('@/components/payment/PaymentMain'));

const ParallaxImageAndDescription = dynamicWithLoader(() => import('@/components/ParallaxImageAndDescription'));

const Partners = dynamicWithLoader(() => import('@/components/Partners'));

const TableModule = dynamicWithLoader(() => import('@/components/TableModule'));

const ExpandingListAndDescription = dynamicWithLoader(() => import('@/components/ExpandingListAndDescription'));

const HeaderDescriptionModule = dynamicWithLoader(() => import('@/components/Header&DescriptionModule'));

const ParallaxSlider = dynamicWithLoader(() => import('@/components/ParallaxSlider'));

const GalleryModule = dynamicWithLoader(() => import('@/components/GalleryModule'));

const HighlightedHeading = dynamicWithLoader(() => import('@/components/HighlightedHeading'));

const TilesModule = dynamicWithLoader(() => import('@/components/TilesModule'));

const CareerModule = dynamicWithLoader(() => import('@/components/CareerModule'));

const PinnedHistoryModule = dynamicWithLoader(() => import('@/components/PinnedHistoryModule'));

const VideoWithCoverModule = dynamicWithLoader(() => import('@/components/VideoWithCoverModule'));

const GalleryDescriptionTextModule = dynamicWithLoader(() => import('@/components/GalleryDescriptionTextModule'));

const ColorfulSquaresModule = dynamicWithLoader(() => import('@/components/ColorfulSquares'));

const Archive = dynamicWithLoader(() => import('@/components/Archive'));

const SignupFormModule = dynamicWithLoader(() => import('@/components/Forms/SignupFormModule'));

const PressMediaFeed = dynamicWithLoader(() => import('@/components/Press'))

const ExpandingTabs = dynamicWithLoader(() => import('@/components/ExpandingTabs'));

const DonorStories = dynamicWithLoader(() => import('@/components/DonorStories'))

const BranchNavigator = dynamicWithLoader(() => import('@/components/BranchNavigator'));

const HeadingGraphic = dynamicWithLoader(() => import('@/components/HeadingGraphicModule'));

const TwoImagesInRowModule = dynamicWithLoader(() => import('@/components/TwoImagesInRowModule'));

const StatesMapModule = dynamicWithLoader(() => import('@/components/Maps'));

const FactsModule = dynamicWithLoader(() => import('@/components/FactsModule'))

const ExpandableVideo = dynamicWithLoader(() => import('@/components/expandingVideo/ExpandingVideo'))

const ChosenNewsModule = dynamicWithLoader(() => import('@/components/ChosenNewsModule'))

const ArticlesList = dynamicWithLoader(() => import('@/components/ArticlesList'))

const CountDownTimer = dynamicWithLoader(() => import('@/components/CountDownTimer'))

function formatTypename(inputStr) {
	let newStr = inputStr.replace(/Record$/, '');
	newStr = newStr.replace(/([A-Z])/g, ' $1').trim();

	return newStr;
}

const ContentSwitcher = ({type, item, index, globalBannerData, isPreviewPage}) => {
	switch (type) {
		// case CONTENT_TYPES.NEWS_THUMBNAIL:
		// 	return <NewsThumbnail key=getMapKey(item, index) data={item}  />;
		// case CONTENT_TYPES.RULES_TILES:
		// 	return <RulesTiles key=getMapKey(item, index) data={item}  />;
		case CONTENT_TYPES.GLOBAL_BASED_BANNER:
			return isPreviewPage ? <SubPageBanner data={item}/> : globalBannerData ?
				<SubPageBanner data={globalBannerData}/> : null
		case CONTENT_TYPES.TABS_AND_IMAGE:
			return <TabsAndImage data={item}/>
		case CONTENT_TYPES.TEXT_AND_DESCRIPTION_WITH_BUTTON:
			return <TextAndDescriptionWithButton data={item}/>
		case CONTENT_TYPES.DESCRIPTION_WITH_IMAGE:
			return <DescriptionWithImage data={item}/>
		case CONTENT_TYPES.CONTACT_FORM_PREVIEW:
			return <ContactForm data={item}/>
		case CONTENT_TYPES.HEADER_AND_DESCRIPTION_MODULE:
			return <HeaderDescriptionModule data={item}/>
		case CONTENT_TYPES.CALENDAR:
			return <Calendar data={item}/>
		case CONTENT_TYPES.FAQ_PREVIEW:
			return <FAQ data={item}/>
		case CONTENT_TYPES.DRAGGABLE_LETTERS:
			return <DraggableLetters data={item}/>
		case CONTENT_TYPES.RULES_TILES:
			return <RulesTiles data={item}/>
		case CONTENT_TYPES.NEWS_THUMBNAIL:
			return <NewsThumbnail data={item}/>
		case CONTENT_TYPES.STRUCTURED_TEXT_MODULE:
			return <StructuredTextModule data={item}/>
		case CONTENT_TYPES.SOCIAL_MEDIA_FEED:
			return <SocialMediaFeed data={item}/>
		case CONTENT_TYPES.STATS:
			return <Stats data={item}/>
		case CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE:
			return <BannerCallToActionModule data={item}/>
		case CONTENT_TYPES.BANNER_CALL_TO_ACTION_MODULE_PREVIEW:
			return <BannerCallToActionPreviewModule data={item}/>
		case CONTENT_TYPES.IMAGE_WITH_CAPTION:
			return <ImageWithCaption data={item}/>
		case CONTENT_TYPES.PAYMENT_MODULE:
			return <Payment data={item}/>
		case CONTENT_TYPES.TEAM_MODULE:
			return <TeamModule data={item}/>
		case CONTENT_TYPES.PARTNERS:
			return <Partners data={item}/>
		case CONTENT_TYPES.PARALLAX_IMAGE_AND_DESCRIPTION:
			return <ParallaxImageAndDescription data={item}/>
		case CONTENT_TYPES.TABLE_MODULE:
			return <TableModule data={item}/>
		case CONTENT_TYPES.TABLE_PREVIEW_MODULE:
			return <TablePreviewModule data={item}/>
		case CONTENT_TYPES.EXPANDING_LIST_AND_DESCRIPTION:
			return <ExpandingListAndDescription data={item}/>
		case CONTENT_TYPES.PARALLAX_SLIDER:
			return <ParallaxSlider data={item}/>
		case CONTENT_TYPES.GALLERY_MODULE:
			return <GalleryModule data={item}/>
		case CONTENT_TYPES.HIGHLIGHTED_HEADING:
			return <HighlightedHeading data={item}/>
		case CONTENT_TYPES.TILES_MODULE:
			return <TilesModule data={item}/>
		case CONTENT_TYPES.CAREER_MODULE:
			return <CareerModule data={item}/>
		case CONTENT_TYPES.PINNED_HISTORY:
			return <PinnedHistoryModule data={item}/>
		case CONTENT_TYPES.VIDEO_WITH_COVER_MODULE:
			return <VideoWithCoverModule data={item}/>
		case CONTENT_TYPES.GALLERY_DESCRIPTION_TEXT_MODULE:
			return <GalleryDescriptionTextModule data={item}/>
		case CONTENT_TYPES.COLORFUL_SQUARES_MODULE:
			return <ColorfulSquaresModule data={item}/>
		case CONTENT_TYPES.SIGNUP_FORM_MODULE:
			return <SignupFormModule data={item}/>
		case CONTENT_TYPES.ARCHIVE:
			return <Archive data={item}/>
		case CONTENT_TYPES.PRESS_MEDIA_FEED:
			return <PressMediaFeed data={item}/>
		case CONTENT_TYPES.TWO_IMAGES_IN_ROW_MODULE:
			return <TwoImagesInRowModule data={item}/>
		case CONTENT_TYPES.EXPANDING_TABS_MODULE:
			return <ExpandingTabs data={item}/>
		case CONTENT_TYPES.DONOR_STORIES:
			return <DonorStories data={item}/>
		case CONTENT_TYPES.BRANCH_NAVIGATOR:
			return <BranchNavigator data={item}/>
		case CONTENT_TYPES.HEADING_GRAPHIC_MODULE:
			return <HeadingGraphic data={item}/>
		case CONTENT_TYPES.STATES_MAP:
			return <StatesMapModule data={item} />
		case CONTENT_TYPES.FACTS_MODULE:
			return <FactsModule data={item} />
		case CONTENT_TYPES.BANNER_TYPOGRAPHY:
			return <TypographyBanner data={item} />
		case CONTENT_TYPES.CHOSEN_NEWS_MODULE:
			return <ChosenNewsModule data={item} />
		case CONTENT_TYPES.EXPANDABLE_VIDEO:
			return <ExpandableVideo data={item} />
		case CONTENT_TYPES.ARTICLES_LIST_PREVIEW_MODULE:
			return <ArticlesList data={item}/>
		case CONTENT_TYPES.KRS_BANNER:
			return <BannerKRS data={item}/>
		case CONTENT_TYPES.GALLERY_PREVIEW_MODULE:
			return <GalleryModule data={item} isPreview={true}/>
		case CONTENT_TYPES.HEADER_DESCRIPTION_PREVIEW_MODULE:
			return <HeaderDescriptionModule data={item} isPreview={true}/>
		case CONTENT_TYPES.TILES_MODULE_PREVIEW:
			return <TilesModule data={item} isPreview={true}/>
		case CONTENT_TYPES.COUNT_DOWN_TIMER_MODULE:
			return <CountDownTimer data={item} />
		default:
			return null;
	}
}

const ContentItem = memo(function Item({item, type, isPreviewPage, globalBannerData}) {
	const formattedItemType = formatTypename(type);

	return (
		<>
			{isPreviewPage && (
				<HeaderDescriptionModule
					data={{
						paddings: {
							top: PADDING.NONE,
							bottom: PADDING.NONE,
						},
						headerDescription: {
							header: formattedItemType,
						},
					}}
				/>
			)}
			<ContentSwitcher item={item} type={type} globalBannerData={globalBannerData} isPreviewPage={isPreviewPage}/>
		</>
	);
})

const ExtendedContent = ({content, globalBannerData = null}) => {
	const {asPath} = useRouter();
	const isPreviewPage = asPath.includes(PAGES.PREVIEW);
	if (!Array.isArray(content)) {
		return null;
	}
	return (
		<>
			{content.map((item, index) => {
				const type = getItemType(item);
				return (
					<ContentItem
						key={getMapKey2(item, index)}
						item={item}
						type={type}
						isPreviewPage={isPreviewPage}
						globalBannerData={globalBannerData}
					/>
				);
			})}
		</>
	);
};

export default ExtendedContent;
